import type { ValuesOf } from '@accesso/cc-std-lib';

export const StorageKey = <const>{
	CART_ID: 'cart_id',
	ANON_TOKEN: 'cc-id',
	SESSION_ID: 'sessionId',
	OIDC_STATE: 'oidc_state',
	OIDC_RETURN_URL: 'oidc_return_url',
};

export type StorageKey = ValuesOf<typeof StorageKey>;
